import React from 'react';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'pt', flag: '🇵🇹', shortLabel: 'PT', nameKey: 'language.portuguese' },
  { code: 'en', flag: '🇬🇧', shortLabel: 'EN', nameKey: 'language.english' },
];

function LanguageSwitcher({ className = '' }) {
  const { t, i18n } = useTranslation();
  const activeLanguage = i18n.resolvedLanguage || i18n.language;

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    window.localStorage.setItem('ambitus-language', language);
    document.documentElement.lang = language;
  };

  return (
    <div className={`language-switcher ${className}`.trim()} aria-label={t('language.selector')}>
      {languages.map(({ code, flag, shortLabel, nameKey }) => (
        <button
          key={code}
          type="button"
          className={`language-option ${activeLanguage === code ? 'is-active' : ''}`}
          aria-label={t(nameKey)}
          aria-pressed={activeLanguage === code}
          onClick={() => changeLanguage(code)}
        >
          <span aria-hidden="true">{flag}</span>
          <span>{shortLabel}</span>
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
